import axios from "axios";
import React from "react";
import { getRequest } from "./QuoteApiService";

export const getCountries = () => {
  const countriesCall = getRequest('GetCountriesAutocomplete/');
  console.log("Services > getCountries called...");

  return new Promise((resolve, reject) => {
    try {
      axios
      .all([countriesCall])
      .then((res) => {
        console.log("getCountries > axios res=", res);
        resolve(res);
      })
      .catch((err) => {
        console.log("getCountries > axios err=", err);
        reject("Error in getCountries axios!");
      });
    } catch (error) {
      console.error("in services > getCountries, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}
